let _paused = true;
let _booms = [];
let _boomks = [];
let _context;
let _Mx, _My;
let _timer1;
let _timer2;
export default class ScreenSaver {
  constructor(canvas, windowW, windowH) {
    this._canvas = canvas;
    this._windowW = windowW;
    this._windowH = windowH;
    this._canvas.width = windowW;
    this._canvas.height = windowH;
    _context = this._canvas.getContext("2d");
    _paused = true;
    _booms = [];
    _boomks = [];
    (_Mx = 0), (_My = 0);
    this.mouseMove();
  }
  creatarry(a, b) {
    for (var i = 0; i < 40; ++i) {
      _booms[i] = {
        x: a,
        y: b,
        gravity: 0.3,
        speedX: Math.random() * 20 - 10,
        speedY: Math.random() * 15 - 7,
        radius: Math.random() * 15,
        color: Math.random() * 360,
        apc: 0.6
      };
      _boomks.push(_booms[i]);
      if (_boomks.length > 300) {
        _boomks.shift();
      }
    }
  }

  movecircles(circle) {
    circle.x += circle.speedX;
    circle.speedY += circle.gravity;
    circle.y += circle.speedY;
    circle.apc -= 0.008;
  }
  canvasMove(x, y) {
    var bbox = this._canvas.getBoundingClientRect();
    return {
      x: x - bbox.left * (this._canvas.width / bbox.width),
      y: y - bbox.top * (this._canvas.height / bbox.height)
    };
  }
  start() {
    clearTimeout(_timer1);
    clearTimeout(_timer2);
    _timer1 = setInterval(() => {
      this.fang();
    }, 50);
    _timer2 = setInterval(() => {
      this.mouseDown();
    }, 1000);
  }
  mouseMove() {
    var loc = this.canvasMove(this._windowW / 2, this._windowH / 5);
    _Mx = loc.x;
    _My = loc.y;
  }
  mouseDown() {
    this.creatarry(_Mx, _My);
    _paused = !_paused;
  }
  loop1() {
    _boomks.forEach((circle) => {
      _context.beginPath();
      _context.arc(circle.x, circle.y, circle.radius, 0, Math.PI * 2, false);
      _context.fillStyle = "hsla(" + circle.color + ",100%,60%," + circle.apc + ")";
      _context.fill();
      this.movecircles(circle);
    });
  }
  fang() {
    _context.clearRect(0, 0, this._canvas.width, this._canvas.height);
    this.loop1();
  }
}



// WEBPACK FOOTER //
// ./src/mainInterface/js/SceenSaver.js